import { ReactNode } from 'react';
import { Box, Card, CardContent } from '@mui/material';
import { GlassHeader } from '@/components/Layout/GlassHeader';

/**
 * Centered card layout used by Login + Register screens.
 * Always renders the glass header at the top so the brand sits
 * consistently on the public pages.
 */
interface Props {
  maxWidth?: number;
  children: ReactNode;
  /** Optional content rendered below the card body (links, etc.). */
  footer?: ReactNode;
}

export function AuthCard({ maxWidth = 460, children, footer }: Props) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <GlassHeader />

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: { xs: 2, sm: 3 },
        }}
      >
        <Box sx={{ maxWidth, width: '100%' }}>
          <Card
            sx={{
              backdropFilter: 'blur(12px)',
              WebkitBackdropFilter: 'blur(12px)',
              background: 'rgba(255, 255, 255, 0.85)',
            }}
          >
            <CardContent sx={{ p: { xs: 3, sm: 4 } }}>{children}</CardContent>
          </Card>
          {footer && <Box sx={{ mt: 2.5, textAlign: 'center' }}>{footer}</Box>}
        </Box>
      </Box>
    </Box>
  );
}
